<script setup>
import HeaderNav from "@/components/headerNav.vue";
import FootNav from "@/components/footNav.vue";
import { ref, onMounted, onUnmounted, nextTick, watch } from 'vue'
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import { useRoute, useRouter } from 'vue-router'
import { getBannerApi, getSimpleListApi, getNewsArticleTypeApi } from "@/api";

const route = useRoute();
const router = useRouter();
const activeItem = ref({})
let type = router.currentRoute.value.query.type
const bannerList = ref([]);
const newsSubItems = ref([]);
const videos = ref([]);
const pageNo = ref(1);
const total = ref(0);
const pageSize = ref(10);
let observer = null;

function getBanner() {
  getBannerApi({ type: 6 }).then(res => {
    bannerList.value = res.data
  })
}

async function getHome() {
  await getSimpleListApi({ type: 6 }).then(res => {
    newsSubItems.value = res.data
    if (type) {
      activeItem.value = newsSubItems.value.find(item => item.id == type)
    } else {
      activeItem.value = newsSubItems.value[0]
    }
    getNewsArticleType()
  })
}

// 设置产品列表项的观察器
function setupVideoListObserver() {
  if (observer) {
    observer.disconnect()
  }

  observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate__fadeInUp')
            observer.unobserve(entry.target)
          }
        })
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
  )

  // 观察所有产品列表项
  const videoElements = document.querySelectorAll('#videoList li')
  videoElements.forEach(el => {
    observer.observe(el)
  })
}

function goDetails(item) {
  router.push({
    path: `/productDetails`,
    query: { id: item.id }
  })
}

function getNewsArticleType() {
  let params = { pageNo: pageNo.value, pageSize: pageSize.value, type: 6, categoryId: activeItem.value.id }
  getNewsArticleTypeApi(params).then(res => {
    videos.value = res.data.list
    total.value = res.data.total

    // 数据更新后重新设置观察器
    nextTick(() => {
      setTimeout(() => {
        setupVideoListObserver()
      }, 100)
    })
  })
}

function pageChange(page, e) {
  console.log(page, e)
  pageNo.value = page
  getNewsArticleType()
}

function switchItem(item) {
  activeItem.value = item
  pageNo.value = 1
  getNewsArticleType()
}

// 监听路由参数变化
watch(
    () => route.query.type,
    (newType) => {
      console.log(newType)
      type = newType
      getHome();
    }
);

onMounted(() => {
  // 组件挂载后设置观察器
  nextTick(() => {
    setTimeout(() => {
      setupVideoListObserver()
    }, 100)
  })
})

onUnmounted(() => {
  if (observer) {
    observer.disconnect()
  }
})

getHome()
getBanner()
</script>

<template>
  <div class="box">
    <HeaderNav :isCurrent="5" />
    <div>
      <!-- 轮播图 -->
      <el-carousel height="600px" autoplay>
        <el-carousel-item style="height: auto ;min-height: 600px" v-for="(item ,index) in bannerList" :key="index">
          <img :src="item.picUrl" :alt="item.title">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div>
      <div class="video">
        <!-- 右侧区域 开始 -->
        <div id="right">
          <div class="right_title">
            <!-- 当前位置 开始 -->
            <div id="location">
              <a href="/" target="_self">{{t('首页')}}</a> &nbsp;&gt;&gt;&nbsp;
              <a href="javascript:;">{{activeItem.name}}</a>
            </div>
          </div>
          <div id="subchannel_main">
            <div id="subchannel">
              <ul class="subchannellist">
                <li
                    class="depth1 animate__animated"
                    v-for="item in newsSubItems"
                    :key="item.id"
                    :class="item.id==activeItem.id ? 'current':''"
                    @click="switchItem(item)"
                >
                  <span>{{item.name}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="right_body minwidth">
            <ul id="videoList" class="productlist">
              <!-- 使用 v-for 循环渲染产品项 -->
              <li
                  v-for="video in videos"
                  :key="video.id"
                  class="n animate__animated"
                  @click="goDetails(video)"
              >
                <div class=" pointer">
                  <div class="InfoPicture">
                    <img
                        :src="video.picUrl"
                        :title="video.title"
                        :alt="video.title"
                    />
                  </div>
                  <div class="InfoWrap">
                    <div class="InfoTitle">{{video.title}}</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <!-- 分页保持不变 -->
          <div class="page_custom">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                @change="pageChange"
                :default-page-size="pageSize"
            />
          </div>
          <div class="right_bottom"></div>
        </div>
        <!-- 右侧区域 结束 -->
        <div class="clear"></div>
      </div>
    </div>
    <div>
      <FootNav />
    </div>
  </div>
</template>

<style scoped lang="scss">
#videoList li {
  opacity: 0;
  transform: translateY(30px);

  &.animate__fadeInUp {
    opacity: 1;
    transform: translateY(0);
    animation-name: fadeInUp;
    animation-duration: 0.6s;
  }
}

.InfoTitle_video_a {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}
</style>
